import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import { throttle } from '../helpers';

$(function () {
  //slick slider
  var _is_sliding = false;
  var pswpElement = document.querySelectorAll('.pswp')[0];

  var gallery;
  var items = [];
  var images = $('.product-single .zoom__img');
  var imagesToClone = $('.product-gallery__list-thumbnail')
  if (!images.length) {
    return;
  }

  images.each(function () {
    var img = $(this);
    var aspectRatio = parseFloat(img.attr('data-aspectratio'));
    var zoomImg = img.attr('data-zoom-src');
    if (zoomImg) {
      items.push({
        src: zoomImg,
        w: 2000 * aspectRatio,
        h: 2000
      });

      const evCache = [];
      let prevDiff = -1;

      const removeEvent = ev => {
        const index = evCache.findIndex(cachedEv => cachedEv.pointerId === ev.pointerId);
        evCache.splice(index, 1);
      }

      const pointermoveHandler = ev => {
        const index = evCache.findIndex(cachedEv => cachedEv.pointerId === ev.pointerId);
        evCache[index] = ev;

        if (evCache.length === 2) {
          evCache.forEach(cachedEvent => {
            cachedEvent.preventDefault();
            cachedEvent.stopPropagation();
          });
          const curDiff = Math.abs(evCache[0].clientX - evCache[1].clientX);

          if (prevDiff > 0) {
            if (curDiff > prevDiff) {
              this.click();
            }
          }

          prevDiff = curDiff;
        }
      }

      const pointerupHandler = ev => {
        removeEvent(ev);

        if (evCache.length < 2) {
          prevDiff = -1;
        }
      }

      const openGallery = e => {
        if (_is_sliding) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        if (evCache.length > 0) {
          pointerupHandler(evCache[0]);
          prevDiff = -1;
        }

        if (window.PREVENT_ZOOM) return;
        if (imagesToClone.length && window.innerWidth > 768) {
          $('body').append('<div class="photoSwipeThumbs"></div>');
        }

        var index = images.index(this);

        var options = {
          index: index,
          zoomEl: false,
          shareEl: false,
          fullscreenEl: false,
          arrowKeys: false,
          counterEl: false,
          showHideOpacity: true,
        };

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        gallery.listen('afterInit', () => {
          document.querySelector('.pswp__button--arrow--right').style.visibility = "hidden";
          document.querySelector('.pswp__button--arrow--left').style.visibility = "hidden";
        })

        gallery.init();
        gallery.zoomTo(1, { x: gallery.viewportSize.x / 2, y: 0 }, 1);

        if (imagesToClone.length && window.innerWidth > 768) {
          gallery.listen('close', function () {
            $('.photoSwipeThumbs').remove();
          });
          imagesToClone.clone().appendTo("div.photoSwipeThumbs");
          $("div.photoSwipeThumbs .product-gallery__list-thumbnail[data-thumbnail-index='" + gallery.getCurrentIndex() + "']").addClass('active');
          $('body').on('click', 'div.photoSwipeThumbs .product-gallery__list-thumbnail', function (e) {
            $(this).siblings().removeClass("active");
            $(this).addClass('active');
            gallery.goTo($(this).data('thumbnail-index'));
            gallery.zoomTo(1, { x: gallery.viewportSize.x / 2, y: 0 }, 1);

          });
        }
      };

      img.on('click', (e) => {
        openGallery(e);
      });

      this.onpointerdown = (ev) => {
        evCache.push(ev);
      };
      this.onpointermove = throttle(pointermoveHandler, 150, null);
      this.onpointerup = pointerupHandler;
      this.onpointercancimg = pointerupHandler;
      this.onpointerout = pointerupHandler;
      this.onpointerleave = pointerupHandler;
    }
  });
});
